import React, {PureComponent} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper/index'
import Exception from '../../../components/Exception'


import moment from 'moment'

import {Button, Card, Col, Form, Icon, Input, notification, Radio, Row, Select, Table, Tabs, Tooltip} from 'antd'
import _ from 'lodash'

import {hideLoader, showLoader} from '../../../modules/actions/index'
import StudentHeader from '../../../components/studentHeader/index'
import StudentInfo from '../../../components/StudentInfo'

import Request from '../../../request'
import {connect} from 'react-redux'
import {getUrlPushWrapper} from '../../../routes'

const Option = Select.Option
const RadioGroup = Radio.Group
const TabPane = Tabs.TabPane
const config = {
    rules: [{type: 'object', required: true, message: 'Please select time!'}]
}


@Form.create()
class Courier extends PureComponent {
    state = {

        docketNumber: '',
        details: '',
        date: '',
        data: [],
        To: '',
        type: '',
        info: null,
        inquiryId: null,
        allow: true,
        count: 0
    }

    constructor(props) {
        super(props)
        this.table = React.createRef()
    }

    async componentDidMount() {

        let searchParams = new URLSearchParams(this.props.search)

        let inquiryId = searchParams.get('id')
        let {doc, allow} = await Request.getInquiry(inquiryId)
        if (doc && allow) {
            this.setState({info: doc, inquiryId})
            let {info} = this.state
            this.setState({
                data:
                    info && info.courierDetails
                        ? info.courierDetails
                        : []
            })
        } else {
            this.setState({allow: false})
        }


    }

    callback = key => {
        let inputTypes = this.state.inputTypes
    }
    handleSubmit = async () => {

        const {dispatch, form} = this.props


        let values = _.clone(this.state.data)
        let obj = {
            courierDetails: values,
            _id: this.state && this.state.inquiryId
        }

        dispatch(showLoader())

        let x = await Request.addCourierDetails(obj)

        dispatch(hideLoader())


        if (!x.error) {
            notification.success({
                message: 'Success',
                description: x.msg
            })

        } else {
            notification.error({
                message: 'Error Saving',
                description: x.msg
            })
        }


    }

    refreshFxn = () => {
        this.setState({refreshChild: !this.state.refreshChild})
    }


    onSubmit = e => {


        const {dispatch, form} = this.props

        e.preventDefault()

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {


                let y = []
                let x = this.state


                if (!x.type) {
                    return notification.warning({
                        message: 'Required: Type',
                        description: x.msg
                    })
                }
                if (!x.to) {
                    return notification.warning({
                        message: 'Required: To/From',
                        description: x.msg
                    })
                }
                if (!x.docketNumber) {
                    return notification.warning({
                        message: 'Required: Docket Number',
                        description: x.msg
                    })
                }
                if (!x.date) {
                    return notification.warning({
                        message: 'Required: Date in DD/MM/YYYY format',
                        description: x.msg
                    })
                }

                y.push({
                    to: x.to,
                    docketNumber: x.docketNumber,
                    details: x.details,
                    date: x.date,
                    type: x.type
                })


                this.setState({
                    to: null,
                    docketNumber: null,
                    details: null,
                    type: null,
                    date: null,
                    data: [...this.state.data, ...y]
                })


            }
        })


    }


    render() {
        const {submitting, dispatch} = this.props
        const {info, allow} = this.state

        const {
            form: {getFieldDecorator, getFieldValue, setFieldsValue}
        } = this.props

        const typeOption = [
            'Received',
            'Send'

        ]

        // let inputTypes = {
        //   fields: [
        //     {
        //       label: 'To/From',
        //       key: 'type',
        //       type: 'textarea',
        //       required: true
        //
        //     },
        //     {
        //       label: 'Docket Number',
        //       key: 'docketNumber',
        //       required: true,
        //       type: 'text'
        //     },
        //     {
        //       label: 'Courier Details',
        //       key: 'details',
        //       required: true,
        //       type: 'textarea'
        //     },
        //     {
        //       label: 'Date',
        //       key: 'date',
        //       required: true,
        //       type: 'date'
        //     }
        //   ]
        // }

        const columns = [
            {
                title: 'Type',
                key: 'type',
                dataIndex: 'type'

            },
            {
                title: 'To/From',
                key: 'to',
                dataIndex: 'to'

            },
            {
                title: 'Docket Number',
                key: 'docketNumber',
                dataIndex: 'docketNumber'
            },

            {
                title: 'Courier Details',
                key: 'details',
                dataIndex: 'details'
            },


            {
                title: 'Date ',
                key: 'date',
                dataIndex: 'date',
                render: (val, record) => {
                    return (<div>
                        {moment(record.date).format('DD-MM-YYYY')}
                    </div>)
                }
            },
            {
                title: 'Action',
                key: 'operation',
                icon: 'trash',

                render: (val, record) => (
                    <React.Fragment>
                        <Tooltip title="Delete">
                            <Button
                                shape="circle"
                                onClick={() => {
                                    let tt = this.state.data
                                    tt = _.reject(tt, val)
                                    this.setState({data: tt})
                                }}
                                icon="delete"
                                size={'small'}
                            />
                        </Tooltip>
                    </React.Fragment>
                )
            }
        ]


        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 8},
                md: {span: 8}
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16},
                md: {span: 12}
            }
        }

        const submitFormLayout = {
            wrapperCol: {
                xs: {span: 24, offset: 0},
                sm: {span: 10, offset: 7},
                md: {span: 12, offset: 8}
            }
        }

        return (
            allow ?
                <PageHeaderWrapper title={'Courier Details'}>

                    {
                        info && info._id ? <div style={{marginBottom: 10}}>
                            <StudentHeader
                                info={this.state.inquiryId}
                                data={info}
                                done={() => {
                                    dispatch(getUrlPushWrapper('desk.counselling'))
                                }}
                                dispatch={this.props.dispatch}
                            />
                        </div> : null
                    }

                    {
                        info ? <Card bordered={true} style={{marginBottom: 10}}>
                            <StudentInfo
                                info={info}

                            />
                        </Card> : null
                    }


                    <Card bordered={true}>

                        <Form onSubmit={this.onSubmit} style={{marginTop: 8}}>


                            <Form.Item>
                                <Row>
                                    <Col span={6}></Col>

                                    <Col span={3}><label>Type:</label></Col>
                                    <Col span={10}> <RadioGroup
                                        options={typeOption}
                                        required={true}
                                        onChange={v => {
                                            this.setState({
                                                type: v.target.value
                                            })
                                            this.props.form.setFieldsValue({
                                                type: v.target.value
                                            })
                                        }}
                                        value={this.state.type}
                                    /></Col>

                                </Row>
                            </Form.Item>
                            <Form.Item>
                                <Row>
                                    <Col span={6}>

                                    </Col>
                                    <Col span={3}><label>To/From:</label>

                                    </Col>
                                    <Col span={10}><Input value={this.state.to}
                                                          type={'textarea'}
                                                          required={true}
                                                          onChange={py => {
                                                              py = py.target.value
                                                              this.setState({to: py})
                                                          }}></Input>

                                    </Col>
                                </Row>


                            </Form.Item>
                            <Form.Item>
                                <Row>
                                    <Col span={6}>

                                    </Col>
                                    <Col span={3}><label>Docket Number:</label></Col>
                                    <Col span={10}> <Input value={this.state.docketNumber}

                                                           onChange={py => {
                                                               py = py.target.value
                                                               this.setState({docketNumber: py})
                                                           }}></Input>

                                    </Col>
                                </Row>


                            </Form.Item>
                            <Form.Item>
                                <Row>
                                    <Col span={6}>

                                    </Col>
                                    <Col span={3}><label>Courier Details:</label></Col>
                                    <Col span={10}> <Input value={this.state.details}

                                                           type={'textarea'}
                                                           onChange={py => {
                                                               py = py.target.value
                                                               this.setState({details: py})
                                                           }}></Input>

                                    </Col>
                                </Row>


                            </Form.Item>
                            <Form.Item>
                                <Row>
                                    <Col span={6}>

                                    </Col>
                                    <Col span={3}><label>Date:</label></Col>
                                    <Col span={10}> <Input value={this.state.date}

                                                           type={'date'}
                                                           onChange={py => {
                                                               py = py.target.value
                                                               this.setState({date: py})
                                                           }}></Input>

                                    </Col>
                                </Row>


                            </Form.Item>
                            <Form.Item>
                                <Col span={12}></Col>
                                <Col span={12}>
                                    <Button size={'small'} htmlType="submit" loading={this.props.loading}>
                                        Add Details {<Icon type={'down'}/>}
                                    </Button></Col>

                            </Form.Item>


                            <div>
                                <Table
                                    size={'small'}
                                    pagination={{
                                        defaultPageSize: 10,
                                        showSizeChanger: false,
                                        showQuickJumper: false
                                    }}
                                    bordered={true}
                                    columns={columns}
                                    dataSource={this.state.data}
                                />

                            </div>


                        </Form>
                        <br></br>
                        <br></br>
                        <div>
                            <Row>
                                <Col span={12}></Col>
                                <Col span={12}> <Button
                                    type={'primary'}
                                    onClick={() => this.handleSubmit()}
                                    loading={this.props.loading}>
                                    {<Icon type={'save'}/>}
                                    Save Finally
                                </Button></Col>
                            </Row>

                        </div>
                    </Card>
                </PageHeaderWrapper> : <Exception/>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    categories: global.categories,
    search: router.location.search,
    pathname: router.location.pathname
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Courier)
